module.exports = "<template class=\"table-loading\">\r\n    <slot></slot>\r\n</template>\r\n";